import React, { useContext, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { get } from "lodash";
import { LoaderWrapper, Header } from "../../../components";
import { withAppLayout } from "../../../hoc";
import {
  ManageFeeProvider,
  manageFeeStore,
  setManageFeeSelectedMenu,
} from "../../../contexts";
import ManageFeeMenu from "../../../components/ManageFeeMenu";
import { MANAGE_FEE_MENU } from "../../../utils/constants/fee";
import { ManageFeeRoutes } from "../../../routes";
export const ManageFee = (props) => {
  const { location } = props;
  const { state, dispatch } = useContext(manageFeeStore);
  const { isFetching } = get(state, "api", {});
  const innerDetailsFlag = get(state, "innerDetailsFlag", false);
  useEffect(() => {
    dispatch(setManageFeeSelectedMenu(location.pathname));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  useEffect(() => {
    if (innerDetailsFlag) {
    }
  }, [innerDetailsFlag]);

  const isLoading = get(state, "isLoading", false);
  return (
    <LoaderWrapper
      isLoading={isLoading || isFetching}
      className="row manage-company-wrapper"
    >
      <Row sm="12" className="h-100">
        <Col md="2" className="manage-company-column manage-menu-items">
          <ManageFeeMenu
            menuList={MANAGE_FEE_MENU}
            selectedMenu={get(state, "selectedMenu")}
          />
        </Col>
        <Col className="app-outer-layout">
          <ManageFeeRoutes />
        </Col>
      </Row>
    </LoaderWrapper>
  );
};

const ManageFeeWithProvider = (props) => {
  return (
    <ManageFeeProvider>
      <ManageFee {...props} />
    </ManageFeeProvider>
  );
};

export default withAppLayout(ManageFeeWithProvider);
